import { Combobox, ComboboxInput, ComboboxPopupContainer } from "@angular/aria/combobox";
import { Listbox, Option } from "@angular/aria/listbox";
import { AsyncPipe, CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { GeraetModel } from "../../../Api/DcoApi/AktenEintraege/GeraetModel";
import { SearchAndSelectDropDownBase } from "./SearchAndSelectDropDownBase";
import { OverlayModule } from '@angular/cdk/overlay';
import { Geraet } from "../../../Api/DcoApi/AktenEintraege/Geraet";
import { RestClient } from "../../../Api/DcoApi/Client/RestClient";
import { switchMap, of, filter, from, Observable, OperatorFunction } from 'rxjs';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {
  afterRenderEffect,
  effect,
  Component,
  Directive,
  computed,
  signal,
  viewChild,
  viewChildren, Input, Output, EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap/typeahead';

@Component({
  imports: [
    Combobox,
    ComboboxInput,
    ComboboxPopupContainer,
    Listbox,
    Option,
    OverlayModule,
    FormsModule,
    AsyncPipe,
    CommonModule,
    NgbTypeahead
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'SeriennummerSelect',
  templateUrl: './SeriennummerSelect.html',
  standalone: true,
  styleUrl: './SeriennummerSelect.css'
})
export class SeriennummerSelect {
  Client: RestClient = new RestClient();

  @Input() enabeld: boolean = true;
  @Input() selection: Geraet | null = null;

  // MUST be named exactly 'addressChange' for [(address)] to work
  @Output() selectionChange = new EventEmitter<Geraet | null>();

  Items: OperatorFunction<string, Geraet[]> = (text$: Observable<string>) =>
    text$.pipe(
      //debounceTime(200),
      switchMap(async (term) => {
        if (term === '') {
          return [];
        }
        // Wir warten auf das Promise der Search-Funktion
        const results = await this.Serach(term);
        return results.slice(0, 10);
      })
    );

  formatter: (obj: Geraet) => string = obj => obj.seriennummer;

  constructor() {

  }

  protected Serach(querry: string): Promise<Geraet[]>  {
      return this.Client.Get<Geraet[]>('/Backend/Api/V2/Geraete/Search?term=' + querry);
    }

    protected triggerChange(res:any)
    {
      var ger = res;

      if(ger === "")
        ger = null;

      this.selectionChange.emit(ger);
    }

}
